/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAreaVS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 1.89V22h20V4.826L18.448 7.87l-4.293-6.44-5.722 5.723L2 1.89zm14.919 7.29-2.934 2.515-3.997-3.27 3.857-3.856 3.074 4.611z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChartAreaVS as ChartAreaVS };
